const getDurationInMinutes = (value) => {
    const secNum = parseInt(value, 10);
    return Math.floor(secNum / 60);
};

export default getDurationInMinutes;
